const de = {
    brand: {
        name: "Maison Noma",
        claim: "Objects for a better living.",
    },

    links: {
        home: "/",
        shop: "/shop",
        shopObjects: "/shop/objects",
        shopLighting: "/shop/lighting",
        shopFurniture: "/shop/furniture",
        shopTextiles: "/shop/textiles",
        cart: "/warenkorb",
        blog: "/blog",
        contact: "/kontakt",
        imprint: "/impressum",
        privacy: "/datenschutz",
        terms: "/agb",
    },

    nav: {
        shop: "Shop",
        journal: "Journal",
        contact: "Kontakt",
        cart: "Warenkorb",
        search: "Suchen",
        menu: "Menü",
    },

    home: {
        heroSection: {
            overline: "Maison Noma",
            title: "Objects for a better living.",
            subtitle:
                "Zeitlose Objekte für modernes Wohnen – sorgfältig ausgewählt, um über Jahre hinweg Bestand zu haben.",
            cta: "Kollektion entdecken",
        },

        categoriesSection: {
            overline: "Kategorien",
            title: "Kuratiert nach Kategorie",
            description: "Vier Kategorien, ein gemeinsamer Massstab: Material, Form und Langlebigkeit.",
            categories: [
                {
                    slug: "objects",
                    title: "Objects",
                    description: "Vasen, Keramik und dekorative Objekte für die ruhigen Momente eines Raumes.",
                    cta: "Objects entdecken",
                },
                {
                    slug: "lighting",
                    title: "Lighting",
                    description: "Tisch-, Steh- und Pendelleuchten, die einen Raum durch Wärme gestalten.",
                    cta: "Lighting entdecken",
                },
                {
                    slug: "furniture",
                    title: "Furniture",
                    description: "Kleinmöbel aus Massivholz und Stein, gebaut für Jahrzehnte statt Saisons.",
                    cta: "Furniture entdecken",
                },
                {
                    slug: "textiles",
                    title: "Textiles",
                    description: "Leinen, Wolle und Jute, die einen Raum weicher machen – mit jeder Nutzung mehr.",
                    cta: "Textiles entdecken",
                },
            ],
        },

        blogTeaserSection: {
            overline: "Journal",
            title: "Aus dem Journal",
            description: "Gedanken zu Material, Raum und der Kunst des bewussten Wohnens.",
            cta: "Alle Artikel lesen",
            readMore: "Weiterlesen",
        },

        productHighlightsSection: {
            overline: "Ausgewählt",
            title: "Featured Objects",
            description: "Eine kleine, sorgfältig kuratierte Auswahl unserer liebsten Stücke.",
            cta: "Alle Objekte ansehen",
        },

        editorialSection: {
            brandStory: {
                eyebrow: "Die Marke",
                title: "Designed to live with you.",
                body:
                    "Maison Noma entwirft zeitlose Objekte, die Material, Funktion und Form miteinander in Einklang bringen. Jedes Stück wird ausgewählt, um über Jahre hinweg Teil eines Zuhauses zu sein – nicht nur einer Saison.",
            },
            philosophy: {
                eyebrow: "Philosophie",
                title: "Weniger, aber besser.",
                body:
                    "Wir glauben an bewussten Konsum: wenige, gut gewählte Objekte statt vieler austauschbarer. Qualität, die man sieht, fühlt und über Jahre zu schätzen weiss.",
            },
            finalStatement: {
                eyebrow: "Für Ihr Zuhause",
                title: "Jedes Objekt, mit Bedacht gewählt.",
                body:
                    "Von der ersten Skizze bis zum fertigen Stück: Wir arbeiten mit Materialien und Handwerk, die einem Zuhause über Jahre hinweg gerecht werden.",
            },
        },

        newsletterSection: {
            title: "Bleiben Sie informiert",
            description:
                "Melden Sie sich an und erhalten Sie Einblicke in neue Objekte, Kollektionen und das Journal.",
            placeholder: "Ihre E-Mail-Adresse",
            cta: "Anmelden",
            disclaimer: "Mit der Anmeldung akzeptieren Sie unsere Datenschutzerklärung. Jederzeit abbestellbar.",
            successMessage: "Danke! Bitte bestätigen Sie Ihre Anmeldung über den Link in Ihrer E-Mail.",
            errorMessage: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        },
    },

    shopPage: {
        hero: {
            title: "Shop",
            description: "Entdecken Sie unsere gesamte Kollektion für ein bewusst gestaltetes Zuhause.",
        },
        breadcrumbShop: "Shop",
        filters: {
            title: "Filter",
            category: "Kategorie",
            productType: "Objektart",
            priceRange: "Preis",
            priceUpTo: "bis {value} €",
            reset: "Filter zurücksetzen",
            apply: "Anwenden",
            sortLabel: "Sortieren nach",
            sortOptions: {
                newest: "Neueste",
                priceAsc: "Preis aufsteigend",
                priceDesc: "Preis absteigend",
                nameAsc: "Name A–Z",
            },
        },
        resultsCount: "{count} Objekte",
        noResults: "Keine Objekte gefunden. Versuchen Sie andere Filter.",
        addToCart: "In den Warenkorb",
        quickView: "Schnellansicht",
    },

    productPage: {
        breadcrumbShop: "Shop",
        addToCart: "In den Warenkorb",
        addedToCart: "Zum Warenkorb hinzugefügt",
        outOfStock: "Ausverkauft",
        inStock: "Auf Lager",
        lowStock: "Nur noch wenige verfügbar",
        quantityLabel: "Menge",
        descriptionTitle: "Beschreibung",
        variantLabel: "Variante",
        relatedTitle: "Das könnte Ihnen auch gefallen",
        goToCart: "Zum Warenkorb",
        materialLabel: "Material",
        dimensionsLabel: "Maße",
        shippingInfoTitle: "Versand & Rückgabe",
        shippingInfoText:
            "Versand innerhalb von 3–5 Werktagen. Kostenlose Rückgabe innerhalb von 30 Tagen. Hinweis: Dies ist eine Portfolio-Demo – es erfolgt kein echter Versand.",
        detailsTitle: "Produktdetails",
    },

    cartPage: {
        title: "Ihr Warenkorb",
        empty: "Ihr Warenkorb ist noch leer.",
        continueShopping: "Weiter einkaufen",
        product: "Objekt",
        quantity: "Menge",
        price: "Preis",
        remove: "Entfernen",
        subtotal: "Zwischensumme",
        shippingNote: "Versandkosten werden im Checkout berechnet.",
        checkoutCta: "Zur Kasse",
        checkoutRedirectNote: "Sie werden zu einer Demo-Kasse weitergeleitet – es erfolgt keine echte Zahlung.",
    },

    cartDrawer: {
        title: "Warenkorb",
        empty: "Ihr Warenkorb ist noch leer.",
        subtotal: "Zwischensumme",
        viewCart: "Warenkorb ansehen",
        checkout: "Zur Kasse",
        close: "Schließen",
    },

    blogPage: {
        hero: {
            title: "Journal",
            description: "Gedanken zu Material, Raum und der Kunst des bewussten Wohnens.",
        },
        categoryFilterLabel: "Kategorie",
        allCategories: "Alle Artikel",
        readMore: "Weiterlesen",
        noResults: "Keine Artikel in dieser Kategorie gefunden.",
    },

    blogArticlePage: {
        backToBlog: "Zurück zum Journal",
        relatedArticlesTitle: "Das könnte Sie auch interessieren",
        relatedProductsTitle: "Passende Objekte",
        publishedOn: "Veröffentlicht am",
        minuteReadLabel: "Min. Lesezeit",
    },

    contactPage: {
        overline: "Kontakt",
        title: "Wir sind für Sie da",
        description:
            "Fragen zu einem Objekt, Ihrer Bestellung oder einfach nur Feedback? Schreiben Sie uns – wir melden uns schnellstmöglich.",
        address: "Maison Noma, Musterstraße 1, 10115 Berlin",
        phoneNumber: "+49 30 1234 5678",
        email: "hallo@maison-noma.de",
        form: {
            name: {
                label: "Name *",
                placeholder: "Ihr Name",
                helperText: "Name darf nicht leer sein",
            },
            email: {
                label: "E-Mail *",
                placeholder: "ihre@email.com",
                helperText: "E-Mail-Adresse darf nicht leer sein",
            },
            message: {
                label: "Nachricht *",
                placeholder: "Wie können wir Ihnen helfen?",
                helperText: "Ihre Nachricht muss mindestens 10 Zeichen enthalten.",
            },
            terms: "Ich akzeptiere die ",
            termsLink: "Datenschutzerklärung",
            submit: "Nachricht senden",
            successMessage: "Danke für Ihre Nachricht! Wir melden uns bald bei Ihnen.",
            errorMessage: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut.",
        },
    },

    footerText: {
        description: "Zeitlose Objekte für modernes Wohnen – sorgfältig ausgewählt für ein bewusst gestaltetes Zuhause.",
        shopTitle: "Shop",
        shopObjects: "Objects",
        shopLighting: "Lighting",
        shopFurniture: "Furniture",
        shopTextiles: "Textiles",
        allProducts: "Alle Objekte",
        contentTitle: "Journal",
        blog: "Journal",
        aboutUs: "Über uns",
        legalTitle: "Rechtliches",
        imprint: "Impressum",
        privacy: "Datenschutz",
        terms: "AGB",
        contact: "Kontakt",
        copyright: "Maison Noma. Alle Rechte vorbehalten.",
    },

    imprintText: {
        title: "Impressum",
        companyName: "Maison Noma",
        address: "Musterstraße 1, 10115 Berlin",
        representative: "Vertreten durch: [Name der Geschäftsführung]",
        registerNote: "Registergericht: [Amtsgericht] – Registernummer: [HRB xxxxx]",
        vatId: "Umsatzsteuer-ID gemäß §27a UStG: [DE xxxxxxxxx]",
        contactTitle: "Kontakt",
        phone: "+49 30 1234 5678",
        email: "hallo@maison-noma.de",
        responsibleTitle: "Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV",
        responsibleName: "[Name der verantwortlichen Person]",
        disclaimerTitle: "Hinweis",
        disclaimerText:
            "Dies ist eine Platzhalter-Seite für ein Portfolio-Projekt. Maison Noma ist eine fiktive Marke; auf dieser Website findet kein echter Verkauf statt. Die finalen rechtlichen Angaben müssten vor einem echten Live-Gang durch einen Rechtsbeistand geprüft werden.",
    },

    privacyText: {
        title: "Datenschutzerklärung",
        responsibleTitle: "Verantwortliche Stelle",
        responsibleText: "Maison Noma, Musterstraße 1, 10115 Berlin, hallo@maison-noma.de",
        purposeTitle: "Zweck dieser Demo",
        purposeText:
            "Diese Website ist eine reine Portfolio-Demonstration. Es werden keine echten Bestellungen, Zahlungen oder Kundendaten verarbeitet; der Checkout-Prozess ist simuliert.",
        collectedDataTitle: "Erhobene Daten",
        collectedDataText:
            "Diese Demo verwendet lokale Browser-Speicherung (localStorage) ausschließlich zur Simulation des Warenkorbs. Es werden keine Daten an einen Server übertragen.",
        thirdPartyTitle: "Eingesetzte Dienstleister",
        thirdPartyText:
            "Es werden keine externen Zahlungs- oder Versanddienstleister eingebunden. Produktbilder werden von Unsplash geladen.",
        legalBasisTitle: "Rechtsgrundlage",
        legalBasisText: "Nicht anwendbar – es werden keine personenbezogenen Daten verarbeitet.",
        storageDurationTitle: "Speicherdauer",
        storageDurationText: "Warenkorb-Daten verbleiben ausschließlich lokal in Ihrem Browser, bis Sie diese löschen.",
        yourRightsTitle: "Ihre Rechte",
        yourRightsText:
            "Da keine personenbezogenen Daten verarbeitet werden, entfallen die üblichen Betroffenenrechte für diese Demo.",
        disclaimerText:
            "Dies ist eine Platzhalter-Seite für ein Portfolio-Projekt und ersetzt keine rechtliche Prüfung vor einem echten Live-Gang.",
    },

    termsText: {
        title: "Allgemeine Geschäftsbedingungen",
        scopeTitle: "Geltungsbereich",
        scopeText:
            "Diese Website ist eine Portfolio-Demonstration der fiktiven Marke Maison Noma. Es kommt kein echter Kaufvertrag zustande.",
        contractTitle: "Vertragsschluss",
        contractText:
            "Der Checkout auf dieser Website ist eine Simulation zu Demonstrationszwecken. Es wird keine Bestellung ausgelöst und keine Zahlung verarbeitet.",
        pricesTitle: "Preise & Versand",
        pricesText: "Alle angezeigten Preise sind fiktiv und dienen ausschließlich der Illustration.",
        withdrawalTitle: "Widerrufsrecht",
        withdrawalText: "Da kein echter Kauf stattfindet, ist ein Widerrufsrecht nicht anwendbar.",
        disclaimerText:
            "Dies ist eine Platzhalter-Seite für ein Portfolio-Projekt und ersetzt keine rechtliche Prüfung vor einem echten Live-Gang.",
    },

    common: {
        loading: "Wird geladen…",
        error: "Etwas ist schiefgelaufen.",
        currency: "EUR",
        from: "ab",
        skipToContent: "Zum Inhalt springen",
        newBadge: "Neu",
        wasPrice: "Statt",
        youSave: "Sie sparen",
        addToWishlist: "Zur Merkliste hinzufügen",
        removeFromWishlist: "Von der Merkliste entfernen",
        addToCart: "In den Warenkorb",
        added: "Hinzugefügt",
    },

    checkoutDemoPage: {
        title: "Dies ist eine Demo",
        message:
            "Maison Noma ist ein Portfolio-Projekt. Es wurde keine echte Bestellung aufgegeben und keine Zahlung verarbeitet.",
        backToShopCta: "Zurück zum Shop",
    },

    notFoundPage: {
        title: "Seite nicht gefunden",
        description: "Die gesuchte Seite existiert nicht oder wurde verschoben.",
        cta: "Zurück zur Startseite",
    },
};

export default de;
export type TranslationSchema = typeof de;
